import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { Loader } from "rsuite";

/**
 * The pieces PlaceBid and SecodaryPlaceBid both show (FE-16). Each page lays them out itself, so
 * a change to one of them is made here, not in a page.
 */

/**
 * "Bidding Ended": won or lost, after a final close. Any other prop goes to the Modal -
 * SecodaryPlaceBid's returns to the Secondary Market when it is dismissed.
 */
export const LotResultModal = ({ show, won, footer = false, ...modalProps }) => (
  <Modal show={show} {...modalProps}>
    <Modal.Header>
      <Modal.Title>Bid Status</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {won ? (
        <h4>
          <span className="text-success">Congratulations,</span>You won the auction
        </h4>
      ) : (
        <h4>Sorry, You lost the auction</h4>
      )}
    </Modal.Body>
    {footer && <Modal.Footer></Modal.Footer>}
  </Modal>
);

/**
 * The lot's clock: "Bidding Ended" once the lot has ended, "Paused" for a Paused lot (FE-14 QA:
 * no frozen time, and the page returns to its list - see useLotPage), "Upcoming", or the countdown -
 * red in its last 10 seconds. Nothing is shown before the lot has loaded.
 */
export const LotClockPanel = ({ ended, lot, seconds, countdownText }) => (
  <div className="group-auctionBid-date">
    {ended ? (
      <Col md={12}>
        <p>Bidding Ended</p>
      </Col>
    ) : (
      <Row>
        <Col md={12}>
          {!lot ? (
            <Loader />
          ) : lot.status === "Paused" ? (
            <p className="text-danger">Paused</p>
          ) : lot.status === "Upcoming" ? (
            <p>Upcoming</p>
          ) : (
            <span style={{ color: seconds <= 10 ? "red" : "white" }}>{countdownText}</span>
          )}
        </Col>
      </Row>
    )}
  </div>
);

/** One of the lot's figures: a label over a disabled field. */
export const LotField = ({ md, className, labelClassName = "mt-3", label, name, value }) => (
  <Form.Group as={Col} md={md} className={className} controlId={`lot-${name}`}>
    <Form.Label className={labelClassName}>{label}</Form.Label>
    <InputGroup>
      <Form.Control
        type="text"
        name={name}
        disabled
        value={value}
        style={{ height: "46px" }}
        aria-describedby="inputGroupPrepend"
      />
    </InputGroup>
  </Form.Group>
);

/** The minimum next bid (#176: currentBidAmount, never the price). */
export const MinimumNextBid = ({ amount }) => (
  <Col md="6">
    <Form.Label className="mt-3">Minimum Next Bid </Form.Label>
    <h2 className="currentBid">{amount}</h2>
  </Col>
);

/** The amount the player may type instead of bidding the minimum next bid. */
export const CustomBidField = ({ value, onChange }) => (
  <Col md="6" className="mt-3">
    <Form.Group controlId="lot-bidAmount">
      <Form.Label>Custom Bid Amount</Form.Label>
      <InputGroup>
        <Form.Control
          type="number"
          style={{ height: "46px" }}
          name="bidAmount"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder="Enter your custom bid amount"
          aria-describedby="inputGroupPrepend"
        />
      </InputGroup>
    </Form.Group>
    <p className="mt-2"> All Bidding Amount is in USD</p>
  </Col>
);

/**
 * The bid button - a loader instead while the lot loads or a bid is on its way, nothing for a lot
 * without a numeric starting bid - and the note for the player who leads.
 */
export const BidAction = ({ loading, hidden, canBid, onBid, isHighBidder }) => (
  <>
    {loading ? (
      <Loader />
    ) : hidden ? (
      ""
    ) : (
      <Button type="button" disabled={!canBid} onClick={onBid} className="update-btn-prof ms-0">
        Place My Bid
      </Button>
    )}
    {isHighBidder ? <p className="bidWinner mt-3">You are the highest bidder</p> : ""}
  </>
);
